module.exports = __webpack_public_path__ + "img/2024-07-01d_1.8879b357.jpg";